/* YESSKIN · Landing "Uvola" — interacciones de las secciones uv-* (sin dependencias). */
(function () {
  'use strict';
  if (window.__uvLanding) return;
  window.__uvLanding = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  /* ---------------- aparición al hacer scroll ---------------- */
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function scanReveal(root) {
    $$('[data-uv-reveal]:not(.is-in), [data-uv-cmp]:not(.is-in)', root).forEach(function (el) {
      if (revealIO) revealIO.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------------- cuenta regresiva ---------------- */
  function initCountdown(el) {
    if (el.__uv) return; el.__uv = true;
    if (el.getAttribute('data-top') === 'true' && !design) {
      var sec = el.closest('.shopify-section');
      if (sec && document.body.firstElementChild !== sec) document.body.insertBefore(sec, document.body.firstElementChild);
    }
    var hEl = $('[data-uv-h]', el), mEl = $('[data-uv-m]', el), sEl = $('[data-uv-s]', el);
    var mode = el.getAttribute('data-mode');
    var end;
    function nextEnd() {
      if (mode === 'hours') {
        var key = 'uv-cd-end', hrs = parseInt(el.getAttribute('data-hours'), 10) || 3, saved = 0;
        try { saved = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
        if (!saved || saved < Date.now()) { saved = Date.now() + hrs * 3600000; try { localStorage.setItem(key, saved); } catch (e) {} }
        return saved;
      }
      var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime();
    }
    end = nextEnd();
    function set(node, v) {
      v = v < 10 ? '0' + v : '' + v;
      if (node.textContent !== v) { node.textContent = v; if (!reduce) { node.classList.remove('is-tick'); void node.offsetWidth; node.classList.add('is-tick'); } }
    }
    function tick() {
      var left = Math.max(0, end - Date.now());
      if (left <= 0) { end = nextEnd(); left = end - Date.now(); }
      var t = Math.floor(left / 1000);
      set(hEl, Math.floor(t / 3600)); set(mEl, Math.floor((t % 3600) / 60)); set(sEl, t % 60);
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------------- puntos / rayas de paginación ---------------- */
  function buildDots(containers, count, go) {
    containers.forEach(function (c) {
      c.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Ir a ' + (i + 1));
        (function (n) { b.addEventListener('click', function () { go(n); }); })(i);
        c.appendChild(b);
      }
    });
  }
  function markDots(containers, idx) {
    containers.forEach(function (c) { $$('button', c).forEach(function (b, i) { b.classList.toggle('is-active', i === idx); }); });
  }

  /* carrusel con scroll-snap: calcula el índice por la posición */
  function snapper(track, slides, dots, onChange) {
    var idx = -1;
    function current() {
      var left = track.scrollLeft, best = 0, bestD = Infinity, base = slides[0] ? slides[0].offsetLeft : 0;
      slides.forEach(function (s, i) { var d = Math.abs((s.offsetLeft - base) - left); if (d < bestD) { bestD = d; best = i; } });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = slides.length - 1;
      return best;
    }
    function update() { var i = current(); if (i !== idx) { idx = i; markDots(dots, i); if (onChange) onChange(i); } }
    function go(i) {
      i = (i + slides.length) % slides.length;
      var base = slides[0].offsetLeft;
      track.scrollTo({ left: slides[i].offsetLeft - base, behavior: reduce ? 'auto' : 'smooth' });
    }
    buildDots(dots, slides.length, go);
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    return { go: go, get: function () { return Math.max(idx, 0); } };
  }

  function initGallery(root) {
    if (root.__uv) return; root.__uv = true;
    var track = $('[data-uv-gal-track]', root);
    var slides = $$('[data-uv-gal-slide]', root);
    var dots = $$('[data-uv-gal-dots]', root.closest('[data-uv-product]') || root);
    if (!track || slides.length < 1) return;
    var api = snapper(track, slides, slides.length > 1 ? dots : [], function (i) { slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); }); });
    var p = $('[data-uv-gal-prev]', root), n = $('[data-uv-gal-next]', root);
    if (p) p.addEventListener('click', function () { api.go(api.get() - 1); });
    if (n) n.addEventListener('click', function () { api.go(api.get() + 1); });
  }

  function initSlider(root) {
    if (root.__uv) return; root.__uv = true;
    var track = $('[data-uv-slider-track]', root);
    var slides = $$('[data-uv-slide]', root);
    var dots = $$('[data-uv-slider-dots]', root);
    if (!track || !slides.length) return;
    var api = snapper(track, slides, dots);
    var pv = $('[data-uv-slider-prev]', root), nx = $('[data-uv-slider-next]', root);
    if (pv) pv.addEventListener('click', function () { api.go(api.get() - 1); });
    if (nx) nx.addEventListener('click', function () { api.go(api.get() + 1); });
    var every = (parseInt(root.getAttribute('data-autoplay'), 10) || 0) * 1000;
    if (every && !reduce) {
      var timer, paused = false, visible = false;
      var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.3 }) : null;
      if (io) io.observe(root); else visible = true;
      ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach(function (ev) { root.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      root.addEventListener('mouseleave', function () { paused = false; });
      timer = setInterval(function () {
        if (paused || !visible || document.hidden) return;
        var next = api.get() + 1; api.go(next >= slides.length ? 0 : next);
      }, every);
    }
  }

  /* ---------------- opiniones ML: botón "Útil" ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-uv-useful]');
    if (!b) return;
    var on = b.getAttribute('aria-pressed') !== 'true';
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.classList.toggle('is-on', on);
  });

  /* ---------------- acordeón ---------------- */
  function initAccordion(root) {
    if (root.__uv) return; root.__uv = true;
    $$('[data-uv-acc-item]', root).forEach(function (item) {
      var btn = $('[data-uv-acc-btn]', item);
      btn.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        $$('[data-uv-acc-item].is-open', root).forEach(function (o) { if (o !== item) { o.classList.remove('is-open'); $('[data-uv-acc-btn]', o).setAttribute('aria-expanded', 'false'); } });
        item.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------- contador de números ---------------- */
  var countIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      countIO.unobserve(e.target);
      var el = e.target, to = parseFloat(el.getAttribute('data-uv-count')) || 0, dur = 1400, t0 = null;
      if (reduce) { el.textContent = to; return; }
      function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur); var eased = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(to * eased); if (p < 1) requestAnimationFrame(step); }
      el.textContent = '0'; requestAnimationFrame(step);
    });
  }, { threshold: 0.5 }) : null;
  function initCount(el) { if (el.__uv) return; el.__uv = true; if (countIO) countIO.observe(el); }

  /* ---------------- línea de tiempo + parallax (un solo scroll listener) ---------------- */
  var fills = [], pars = [], ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;
      fills.forEach(function (f) {
        var r = f.parentNode.getBoundingClientRect();
        var p = (vh * 0.72 - r.top) / (r.height || 1);
        f.style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(3));
      });
      if (!reduce) pars.forEach(function (el) {
        var host = el.__host, r = host.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var center = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.setProperty('--py', (center * -40 * el.__k).toFixed(1) + 'px');
      });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  function initTimeline(root) { if (root.__uv) return; root.__uv = true; $$('[data-uv-tl-fill]', root).forEach(function (f) { fills.push(f); }); onScroll(); }
  function initParallax(root) {
    if (root.__uv) return; root.__uv = true;
    $$('[data-uv-par]', root).forEach(function (el) { el.__host = root; el.__k = parseFloat(el.getAttribute('data-uv-par')) || 1; pars.push(el); });
    onScroll();
  }

  /* ---------------- reseñas: ver más / ver menos ---------------- */
  function initMore(root) {
    if (root.__uv) return; root.__uv = true;
    var btn = $('[data-uv-more-btn]', root); if (!btn) return;
    btn.addEventListener('click', function () {
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) { var t = root.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: t, behavior: reduce ? 'auto' : 'smooth' }); }
    });
  }

  /* ---------------- producto: packs, carrito, barra fija ---------------- */
  function scrollToBuy() {
    var f = $('[data-uv-form]'); if (!f) return false;
    var t = f.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: t, behavior: reduce ? 'auto' : 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-uv-scroll-buy]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) === '#' || href === '') { if (scrollToBuy()) e.preventDefault(); }
  });


  /* Ir directo al checkout con un "cart permalink" de Shopify (/cart/ID:CANT,ID:CANT).
     Shopify arma el checkout con esos productos sin pasar por el carrito ni por scripts de otras apps. */
  function ykDirectCheckout(items) {
    var map = {}, order = [];
    items.forEach(function (it) {
      var id = String(it.id); if (!/^\d+$/.test(id)) return;
      if (!map[id]) { map[id] = 0; order.push(id); }
      map[id] += parseInt(it.quantity, 10) || 1;
    });
    if (!order.length) return;
    window.location.href = '/cart/' + order.map(function (id) { return id + ':' + map[id]; }).join(',');
  }

  function initProduct(root) {
    if (root.__uv) return; root.__uv = true;
    var form = $('[data-uv-form]', root); if (!form) return;
    var idInput = $('[data-uv-id]', form), qtyInput = $('[data-uv-qty]', form);
    var offers = $$('[data-uv-offer]', form);
    var mainBtn = $('.uv-atc', form);
    var priceEl = $('[data-uv-atc-price]', form), wasEl = $('[data-uv-atc-was]', form);
    var sticky = $('[data-uv-sticky]', root);
    var allBtns = $$('[data-uv-atc]', root);

    function select(o, silent) {
      offers.forEach(function (x) { var on = x === o; x.classList.toggle('is-selected', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      idInput.value = o.getAttribute('data-variant');
      qtyInput.value = o.getAttribute('data-qty') || 1;
      root.__uvGifts = (o.getAttribute('data-gifts') || '').split(',').filter(function (g) { return /^\d+$/.test(g); });
      var ok = o.getAttribute('data-available') !== 'false';
      allBtns.forEach(function (b) { b.disabled = !ok; });
      var lab = $('.uv-atc__label', mainBtn);
      if (lab) lab.textContent = ok ? lab.getAttribute('data-label') : (mainBtn.getAttribute('data-soldout') || 'AGOTADO');
      if (priceEl) {
        priceEl.textContent = o.getAttribute('data-price');
        if (!silent && !reduce) { priceEl.classList.remove('is-flip'); void priceEl.offsetWidth; priceEl.classList.add('is-flip'); }
      }
      if (wasEl) wasEl.textContent = o.getAttribute('data-compare') || '';
      var note = $('[data-uv-save-note]', root);
      if (note) {
        var sv = o.getAttribute('data-save') || '';
        var amt = $('[data-uv-save-amount]', note);
        if (amt) amt.textContent = sv;
        note.hidden = !sv;
        if (sv && !silent && !reduce) { note.classList.remove('is-pop'); void note.offsetWidth; note.classList.add('is-pop'); }
      }
    }
    offers.forEach(function (o) {
      o.addEventListener('click', function () { select(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(o); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault(); var i = offers.indexOf(o) + (e.key === 'ArrowDown' ? 1 : -1);
          var n = offers[(i + offers.length) % offers.length]; select(n); n.focus();
        }
      });
    });
    var initial = offers.filter(function (o) { return o.classList.contains('is-selected'); })[0] || offers[0];
    if (initial) select(initial, true);

    function add(btn) {
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var drawer = document.querySelector('cart-drawer');
      var goCheckout = root.getAttribute('data-checkout') === 'true';
      var body = { items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }] };
      /* regalos (eBooks) del pack elegido: se suman al carrito y el descuento automático los deja en $0 */
      (root.__uvGifts || []).forEach(function (g) { body.items.push({ id: parseInt(g, 10), quantity: 1, properties: { '_regalo': 'Uvola' } }); });
      if (goCheckout) { btn.classList.add('is-loading'); ykDirectCheckout(body.items); return; }
      if (drawer && !goCheckout) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.classList.remove('is-loading');
          if (!res.ok || res.j.status) { alert(res.j.description || res.j.message || 'No se pudo agregar al carrito.'); return; }
          if (goCheckout) { btn.classList.add('is-loading'); window.location.href = '/checkout'; return; }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'uv-landing', cartData: res.j }); } catch (e) {} }
          if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
            try { drawer.classList.remove('is-empty'); drawer.renderContents(res.j); return; } catch (e) {}
          }
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () { btn.classList.remove('is-loading'); form.submit(); });
    }
    allBtns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); add(b); }); });
    form.addEventListener('submit', function (e) { e.preventDefault(); add(mainBtn); });

    // barra fija: aparece cuando el botón principal quedó arriba, se oculta mientras se ven los packs
    var anchor = $('[data-uv-atc-main]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var passed = false, formVisible = false;
      function paint() { var on = passed && !formVisible; sticky.classList.toggle('is-on', on); document.body.classList.toggle('uv-has-sticky', passed); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); $$('button', sticky).forEach(function (b) { b.tabIndex = on ? 0 : -1; }); }
      new IntersectionObserver(function (en) { var e = en[0]; passed = !e.isIntersecting && e.boundingClientRect.top < 0; paint(); }).observe(anchor);
      new IntersectionObserver(function (en) { formVisible = en[0].isIntersecting; paint(); }, { threshold: 0.25 }).observe(form);
    }
  }

  /* ---------------- init ---------------- */
  function scan(root) {
    root = root || document;
    /* El carrito va primero y cada parte por separado: si algo decorativo falla, el botón de compra igual funciona. */
    function each(sel, fn) { $$(sel, root).forEach(function (el) { try { fn(el); } catch (e) { if (window.console) console.warn('[uv]', sel, e); } }); }
    each('[data-uv-product]', initProduct);
    try { scanReveal(root); } catch (e) { if (window.console) console.warn('[uv] reveal', e); }
    each('[data-uv-countdown]', initCountdown);
    each('[data-uv-gal]', initGallery);
    each('[data-uv-slider]', initSlider);
    each('[data-uv-acc]', initAccordion);
    each('[data-uv-count]', initCount);
    each('[data-uv-timeline]', initTimeline);
    each('[data-uv-parallax]', initParallax);
    each('[data-uv-more]', initMore);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target;
    if (item.matches && item.matches('[data-uv-acc-item]') && !item.classList.contains('is-open')) { var b = $('[data-uv-acc-btn]', item); if (b) b.click(); }
    if (item.matches && item.matches('[data-uv-offer]')) item.click();
    if (item.matches && item.matches('[data-uv-more-item].is-extra')) { var sec = item.closest('[data-uv-more]'); if (sec && !sec.classList.contains('is-open')) { var mb = $('[data-uv-more-btn]', sec); if (mb) mb.click(); } }
    $$('[data-uv-reveal]', item).concat([item]).forEach(function (el) { if (el.classList) el.classList.add('is-in'); });
  });
})();
